module.exports = __webpack_public_path__ + "img/icon-christmas-9.5aba46d7.svg";